import { useTranslation } from '@exam-room/translations';

import { TableDataCell, TableHeaderCell, TableRow } from '../../../../../components';
import { ExamPreviewResultIcon } from '../../components';

import { columns } from './columns';
import { type TableRowData } from './types';

interface ExamPreviewResultQuestionScoreTableProps {
  rows: TableRowData[];
}

export default function ExamPreviewResultQuestionScoreTable(
  props: Readonly<ExamPreviewResultQuestionScoreTableProps>,
) {
  const { rows } = props;

  const { t } = useTranslation();

  return (
    <div className='w-full'>
      <div className='border-border-divider overflow-hidden rounded-lg border'>
        <table className='w-full'>
          <thead>
            <TableRow className='bg-gray-100'>
              {columns.map((column) => (
                <TableHeaderCell align='left' className={column.cellClassName} key={column.field}>
                  {t(column.headerName)}
                </TableHeaderCell>
              ))}
            </TableRow>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <TableRow key={`row-${index}`}>
                <TableDataCell key={row.no}>{row.no}</TableDataCell>
                <TableDataCell key={row.qid}>{row.qid}</TableDataCell>
                <TableDataCell key={`cell-${index}-scorePerQuestion`}>
                  {row.scorePerQuestion}
                </TableDataCell>
                <TableDataCell key={`cell-${index}-correctAnswer`}>
                  {row.correctAnswer}
                </TableDataCell>
                <TableDataCell key={`cell-${index}-selectedAnswer`}>
                  {row.selectedAnswer}
                </TableDataCell>
                <TableDataCell key={`cell-${index}-result`}>
                  <ExamPreviewResultIcon variant={row.result} />
                </TableDataCell>
              </TableRow>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
